import React from 'react'

import cx from 'classnames'

import pdfLogo from 'assets/images/icon-pdf.png'

export default ({ fileId, fileName, title, className,fileUrl }) => {
  return (
    <a
      title={title}
      href={fileUrl}
      download={`${fileName}.pdf`}
      className={cx(className)}
    >
      <img src={pdfLogo} alt={fileName} />
    </a>
  )
}
